import { Yup } from '@frontman/utils';

export const ageSchema = Yup.object().shape({
  age: Yup.number()
    .integer('Age must be an number')
    .min(18, 'Age must be at least 18')
    .max(90, 'Age must be at most 90')
    .required('Age is required'),
});
